const getFaaPmEditLink = (): Promise<Response> => {

    let url: string = `/api/faapm/editlinks`
      
    return fetch(url, {
      method: 'GET'
    })
      
    };
    export default getFaaPmEditLink;